/*
 * Auction room design tokens.
 *
 * Follows the León Gallery site: 'Bell MT' serif, black / white with hairline greys,
 * square corners and uppercase letter-spaced labels. Status colours are kept close to
 * the room's existing meanings (green = you are winning / sold, red = outbid / unsold,
 * amber = fair warning / reserve not met).
 */

export const FONT = "'Bell MT', serif";

export const R = {
  ink: "#111111",
  text: "#333333",
  secondary: "#666666",
  line: "#E6E6E6",
  lineStrong: "#D6D6D6",
  soft: "#F7F7F5",
  paper: "#FFFFFF",
  dark: "#1A1A1A",
  success: "#2E7D32",
  successBg: "#EEF6EE",
  danger: "#C62828",
  dangerBg: "#FDF0F0",
  warning: "#F2C200",
  warningBg: "#FFF8DB",
  pass: "#00796B",
};

/** Applies the site font to all MUI text inside the room. */
export const roomRootSx = {
  fontFamily: FONT,
  color: R.text,
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiAlert-message, & .MuiListItemText-primary, & .MuiListItemText-secondary":
    { fontFamily: FONT },
};

/** Small uppercase label (e.g. "CURRENT BID"). */
export const labelSx = {
  fontFamily: FONT,
  fontSize: "0.6875rem", // 11px
  fontWeight: 700,
  letterSpacing: "1.2px",
  textTransform: "uppercase",
  color: R.secondary,
  lineHeight: 1.4,
};

export const clamp = (lines) => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  wordBreak: "break-word",
});

/** Primary (black) square button. */
export const primaryButtonSx = {
  bgcolor: R.ink,
  color: "#fff",
  borderRadius: 0,
  boxShadow: "none",
  fontFamily: FONT,
  fontWeight: 700,
  letterSpacing: "2px",
  textTransform: "uppercase",
  minHeight: 48,
  "&:hover": { bgcolor: "#333", boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: R.lineStrong, color: R.secondary },
};

/** Outlined square button. */
export const outlineButtonSx = {
  color: R.ink,
  border: `1px solid ${R.ink}`,
  borderRadius: 0,
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: "0.6875rem",
  letterSpacing: "1.2px",
  textTransform: "uppercase",
  minHeight: 36,
  px: 1.5,
  "&:hover": { bgcolor: R.ink, color: "#fff", borderColor: R.ink },
};

/** Thin scrollbar for scrolling panels. */
export const thinScrollSx = {
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": { width: 6, height: 6 },
  "&::-webkit-scrollbar-thumb": { backgroundColor: "#C9C9C9" },
};
